/**
 * Created by asiulik on 08.12.2017.
 */

define(function(){

    function sliderPagerDefault(slider, index){
        return '<button>' + index +'</button>'
    }

    function sliderPageNumbers(slider, index){

    }

    return {
        SliderPagerDefault: sliderPagerDefault,
        SliderPageNumbers: sliderPageNumbers
    };

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/slider/sliderPager.js